<template>
    <section class="mentor-profile">
        <div class="modal-wrapper" @click.prevent="connect=false" v-if="connect==true">
            <div class="modal-box" @click.stop :style="{ backgroundImage: 'url(' + mentor.featuredImage + ')' }"> <img :src="mentor.avatar" class="avatar">
                <h3>{{mentor.user.firstName}} {{mentor.user.lastName}}</h3> 
                <div class="form-group">
                    <label>I would like you as my mentor because<sup class="red">*</sup>:</label>
                    <textarea rows="3" v-model="request.reason">
                    </textarea>
                </div>

                <div class="form-group">
                    <label>Here is a collection of my recent work (links)<sup class="red">*</sup>:</label>
                    <textarea rows="2" v-model="request.work">
                    </textarea>
                </div>

                <div class="form-group">
                    <label>What I expect to get out of this mentorship<sup class="red">*</sup>:</label>
                    <textarea rows="3" v-model="request.expectations">
                    </textarea>
                </div>

                <div class="required-message">
                    <span class="red"><sup>*</sup> required field</span>
                </div>
                
                
                <!-- <textarea v-model="request"></textarea> -->
                    <button :disabled="!requestComplete" @click.prevent="sendRequest()" class="btn btn-success">Submit</button>
                
            </div>
        </div>

        <div class="panel" v-if="mentor">
            <div class="row mentor-header" :style="{ backgroundImage: 'url(' + mentor.featuredImage + ')' }">
                <div class="col-xs-3 nopad">
                    <img class="avatar" :src="mentor.avatar">
                </div>
                <div class="col-xs-9">
                    <span class="name">Mentor - {{mentor.user.firstName}} {{mentor.user.lastName}}</span>
                    <span class="position">
                        {{mentor.position}}
                            <span v-if="mentor.companyUrl">
                            ,&nbsp;
                        </span>
                        <a v-if="mentor.companyUrl" class="company" :href="mentor.companyUrl" target="_blank">
                            {{mentor.company}}
                        </a>
                    </span>
                    
                    <ul class="specialties">
                        <li v-for="specialty in mentor.specialties">
                            <router-link class="no-underline" :to="'/mentor-selector?q=' + specialty">                                
                                {{specialty | deslugify}}
                            </router-link>
                        </li>
                    </ul>
                    <div class="public-status" v-if="localStorage.roles.includes('OnlineDirector') || localStorage.roles.includes('CampusDirector')">
                    <label><input type="checkbox" v-model="mentor.public" @change="updateMentor()"> Visible on Public Website</label>
<!-- v-if="
                            mentor.status === 'available'
                            && mentor.user.mentees.length < mentor.seats"-->

                    </div>        

                    <button
                        :class="{'disabled': !connectionAllowed || connectionLimitReached || alreadyApproved || alreadySubmitted }"
                        v-if="isAvailable && isCorrectVenue"
                        class="connect"
                        v-tooltip="tooltipText"
                        @click.prevent="connectToMentor()">
                        Connect
                    </button>
                    <div class="current-mentees">
                        <span>Mentees Confirmed:</span>
                        <div v-for="a in mentor.availabilities" class="term-availability">
                            <div>
                                {{a.term.name.split(',')[1].trim()}}
                            </div>
                            <div>
                                <ul v-if="a.status === 'available'">
                                    <li v-for="n in a.seats">
                                        <span class="checkbox">
                                            <i :class="{'green':(n-1) < a.connections.length}" class="fa fa-check"></i>
                                        </span>
                                    </li>
                                </ul>
                                <ul v-else-if="a.status === 'unavailable'">
                                    <li v-for="n in a.seats">
                                        <span class="checkbox" title="Mentor is not available for this term">
                                            <i class="fa fa-remove red"></i>
                                        </span>
                                    </li>
                                </ul>
                               

                            </div>
                        </div>
                        <!-- <ul>
                            <li v-for="n in mentor.seats">
                        <span class="checkbox">
                            <i :class="{'green':(n-1) < mentor.user.mentees.length}" class="fa fa-check"></i>
                        </span>
                        </li>
                        </ul> -->
                    </div>
                </div>
            </div>
            <div class="row mentor-data-section">
                <div class="col-xs-4">
                    <div class="mentor-info">
                        <p>Location: {{mentor.location}}</p>
                        <p v-if="mentor.user.timeZone">Time Zone
                            <br>
                            {{formatTimeZone(mentor.user.timeZone)}}
                            <br>
                            {{calculateTzOffset(mentor.user.timeZone)}} TT Time
                        </p>
                        <p v-if="mentor.status==='available'">Available to mentor {{availableDays}}, {{availableTimes}}, {{venue}}</p>
                        <p v-if="mentor.user.languages.length">Languages - {{mentor.user.languages.join(', ')}}</p>                        
                    </div>
                    
                    
                </div>
                <div class="col-xs-8 bio-wrapper">
                    <h3 class="subsection-header"><span>Biography</span></h3>
                    <div class="bio" v-html="mentor.bio">                        
                    </div>
                    <ul class="links">
                        <li v-for="site in mentor.socialSites">
                            <a :href="site.url" target="_blank" class="no-underline">{{site.site}}</a>
                        </li>
                    </ul>
                    <div v-if="mentor.publicEmail" class="email">
                        <a class="btn btn-success no-underline" :href="'mailto:'+mentor.user.email" target="_blank">Email this Mentor</a>
                    </div>
                    
                </div>
                
            </div>

            <div class="row" v-if="mentor.mentor_software_proficiencies.length">
                <h3 class="text-center subsection-header"><span>Software</span></h3>
                <ul class="tags">
                    <li                         
                        v-for="software in mentor.mentor_software_proficiencies">
                        <div
                            :title="software.proficiencyLevel === 2 ? 'Very Familiar' : 'Familiar'" 
                            :class="'level-'+ software.proficiencyLevel">
                            {{software.mentor_software.name}}
                        </div>
                    </li>
                </ul>
            </div>


                  
            <div class="row" v-if="mentor.mentor_skill_proficiencies.length">
                <h3 class="text-center subsection-header"><span>Skills</span></h3>
                <ul class="tags">
                    <li 
                        v-for="skill in mentor.mentor_skill_proficiencies" 
                        v-if="skill.mentor_skill.name && skill.proficiencyLevel">
                        <div
                            :title="skill.proficiencyLevel === 2 ? 'Very Familiar' : 'Familiar'"
                            :class="'level-'+ skill.proficiencyLevel">
                            {{skill.mentor_skill.name}}
                        </div>
                    </li>
                </ul>
            </div>          

            <div class="row" v-if="mentor.mentor_skill_proficiencies.length || mentor.mentor_software_proficiencies.length">
                <div class="legend">
                    <ul class="tags">
                        <li>
                            <div class="level-2">Expert</div>
                        </li>
                        <li>
                            <div class="level-1">Familiar</div>
                        </li>
                    </ul>
                </div>
            </div>


            <div class="row" v-if="mentor.gallery.length > 0 || (mentor.demoReelUrl && demoReelAccessible)">            
        
                <h3 class="subsection-header text-center"><span>Work Samples</span></h3>
                <slick 
                    ref="gallery-slider" 
                    :options="{
                          arrows: true,
                          dots: false,
                          infinite: false,
                          slidesToShow: 4,                          
                          autoplay: false,
                          swipeToSlide: true,
                          variableWidth: true,
                          prevArrow:`<button type='button' class='slick-prev'>&#x276E;</button>`,
                          nextArrow:`<button type='button' class='slick-next'>&#x276F;</button>`,                          

                    }"
                    @beforeChange="lockSlider"
                    @afterChange="unlockSlider"
                    class="gallery-slider">
                    <div v-if="mentor.demoReelUrl && demoReelAccessible">
                        <div class="demo-reel-thumbnail">
                            <img :src="mentor.demoReelThumbnail">                        
                            <div class="play-button-wrapper cursor-pointer" @click="openLightbox('demoReel',null, mentor.demoReelUrl)">
                                <img class="play-button" src="../assets/img/play-button.png" />                                              
                            </div>
                        </div>
                    </div>                        
                    <div v-for="(image, $index) in mentor.gallery">
                        <img :src="image" @click="openLightbox(mentor.gallery, $index)" />
                    </div>
                    <!-- extra slides to add some space at the end -->
                    <div></div>
                    <div></div>
                </slick>                           
            </div>
            
            <div class="row" v-if="mentor.pastMentoredStudents.length > 0">
                <h3 class="subsection-header text-center"><span>Mentored Student Showcase</span></h3>
                <ul class="mentees">                    
                    <li v-for="student in mentor.pastMentoredStudents">
                        <div class="mentee text-center">
                            <div @click.prevent="mentee = student" class="cursor-pointer">
                                <img :src="student.images[0]">
                                <h5 class="text-center">{{student.name}}</h5>
                            </div>
                            <div class="meta">
                                <a v-if="student.artstation" class="no-underline" :href="student.artstation" target="_blank">Artstation</a>                        
                                <div class="venue"><span v-if="student.venue">{{student.venue}}</span></div>
                            </div>
                        </div>
                    </li>
                </ul>
                

                <ul class="past-students">                    
                    <!-- <li v-for="student in mentor.pastMentoredStudents">                        
                        <div class="header">
                            <div class="avata-wrapper">
                                <img class="avatar" :src="student.avatar">
                            </div>
                            <div class="meta">                                
                                <h4>{{student.name}}</h4>
                                <ul v-if="student.artstation" class="links">
                                    <li>
                                        <a :href="student.artstation" target="_blank">{{student.artstation}}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div>                            
                         
                        </div>
                    </li>
 -->
                </ul>
            </div>

            <div class="row" v-if="mentor.credits.length > 0">
                <h3 class="subsection-header text-center"><span>Credits</span></h3>
                
                <slick 
                    ref="credits-slider" 
                    :options="{
                          arrows: true,
                          dots: false,
                          infinite: false,
                          slidesToShow: 4,                          
                          autoplay: false,
                          swipeToSlide: true,
                          variableWidth: true,
                          prevArrow:`<button type='button' class='slick-prev'>&#x276E;</button>`,
                          nextArrow:`<button type='button' class='slick-next'>&#x276F;</button>`,                          
                    }"
                    class="credits-slider">                                          
                    <div v-for="(image, $index) in mentor.credits">
                        <img :src="image" />
                    </div>
                    <!-- extra slides to add some space at the end -->
                    <div></div>
                    <div></div>
                </slick>                                        
            </div>


        </div>
        
        <div class="overlay" v-if="mentee" @click="mentee = null">
            
            
            <div class="selected-mentee" @click.stop>    
                <i class="fa fa-remove" @click="mentee = null"></i>
                <div class="row">
                    <h3>Mentor &ndash; {{mentor.user.firstName}} {{mentor.user.lastName}}</h3>                
                </div>
                <div class="row">
                    <div class="mentee-info">
                        <h4>Mentee &ndash; {{mentee.name}} <span v-if="mentee.venue"> &ndash; {{mentee.venue}}</span></h4>
                        <a v-if="mentee.artstation" :href="mentee.artstation" target="_blank" class="no-underline">Artstation</a>
                        <a v-if="mentee.linkedin" :href="mentee.linkedin" target="_blank" class="no-underline">LinkedIn</a>
                        <a v-if="mentee.publicEmail" :href="'mailto:'+mentee.email" class="email-button">Email Mentee</a>
                    </div>
                </div>
                <div class="row">
                    <h6 v-if="mentee.term">Semester - {{mentee.term | capitalize}}</h6>
                    <h6 v-if="mentee.path && getPathName(mentee.path)">Path - {{getPathName(mentee.path)}}</h6>
                </div>

                <div class="reel row">
                    <div class="col-xs-5 nopad">     
                        <div v-if="mentee.reel">
                            <div v-if="mentee.reelThumbnail" class="mentee-reel-thumbnail" @click.prevent="openLightbox('menteeReel',null,mentee.reel)">
                                <img v-if="mentee.reel" :src="mentee.reelThumbnail" class="thumbnail"> 
                                <img class="play-button" src="../assets/img/play-button.png" />                                                                
                            </div>
                            <iframe 
                                v-else
                                :src="getEmbedUrl(mentee.reel)" 
                                class="w-full mentee-reel" 
                                width="740" 
                                height="520" 
                                frameborder frameborder="0" 
                                allow="fullscreen" 
                                allowfullscreen>
                            </iframe>                        
                        </div>
                        
                    </div>
                    <div class="col-xs-7">
                        <p v-if="mentee.notes">Additional Notes:</p>
                        <p v-if="mentee.notes">{{mentee.notes}}</p>
                    </div>
                </div>
                <div class="row">                    
                    <ul class="images">
                        <li v-for="(image, $index) in mentee.images">
                            <img :src="image" @click.stop="openLightbox(mentee.images, $index)"/>
                        </li>
                    </ul>
                </div>
                <div class="row" v-if="mentee.testimonial">
                    <h6>Testimonial</h6>
                    <div>
                        <p>{{mentee.testimonial}}</p>
                    </div>
                </div>
                
            </div>        
        </div>

        <div class="lightbox" v-if="lightbox.image || lightbox.video" @click="closeLightbox()">
            <i class="fa fa-remove" @click="closeLightbox()"></i>            
            <div v-if="lightbox.video"  @click="closeLightbox()">
                <iframe 
                    @click.stop
                    :src="getEmbedUrl(lightbox.video)" 
                    class="w-full demo-reel" 
                    width="740" 
                    height="520" 
                    frameborder="0" 
                    allow="autoplay"
                    autoplay="1" 
                    allowfullscreen>                             
                </iframe>
            </div>
            <div v-else>
                <img :src="lightbox.image">            
                <div 
                    @click.stop="lightboxPrev" 
                    class="swiper-button-prev swiper-button-white"
                    :class="{'disabled': lightbox.index === 0}"
                ></div>
                <div 
                    @click.stop="lightboxNext" 
                    class="swiper-button-next swiper-button-white"
                    :class="{'disabled': lightbox.index === lightbox.imageSet.length - 1}"                
                ></div>
            </div>
        </div>
    </section>
</template>
<script>
import mentors from '../services/mentors';
import paths from '../services/paths';

import toastr from 'toastr';
import axios from 'axios';
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import linkifyHtml from 'linkifyjs/html';
import VLazyImage from 'v-lazy-image/v2';
import moment from 'moment';
import Slick from 'vue-slick';
import '../../node_modules/slick-carousel/slick/slick.css';
import { uniqBy } from 'lodash';

function convertDateToAnotherTimeZone(date, timezone) {
  const dateString = date.toLocaleString('en-US', {
    timeZone: timezone
  });
  return new Date(dateString);
}

function extractYouTubeId(url) {
    const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;

    const match = url.match(regex);
  
    return match ? match[1] : null;
}

export default {
    data() {
        return {
            mentorId: this.$route.params.id,
            mentor: null,
            connect: false,
            demoReelAccessible: false,
            mentee: null,
            paths:[],
            connectionLimitReached: false,
            alreadyApproved: false,
            alreadySubmitted: false,            
            lightbox: {
                imageSet: null,
                image: null,
                index: null
            },
            request: {
                reason: null,
                work: null,
                expectations: null
            },
            sliderLocked: false,
            swiperOption: {
                keyboard: {
                    enabled: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            },           
        }
    },
    components: {
        swiper,
        swiperSlide,
        VLazyImage,
        Slick
    },
    async mounted() {
        this.getPaths();
        await this.getMentor();
        this.getRequests();
    },
    methods: {
        lockSlider() {
            this.sliderLocked = true;
        },
        unlockSlider() {
            this.sliderLocked = false;
        },        
        formatTimeZone(tz) {
            const formatter = new Intl.DateTimeFormat("en-US", {
                timeZone: tz,
                timeZoneName: 'long'
            });

            const result = formatter.format(new Date());
            const zoneName = result.split(',')[1];
            return zoneName;
        },
        calculateTzOffset(tz) {                        
            const now = new Date();
            const mentorTimeZone = convertDateToAnotherTimeZone(now, tz);
            const ttoTimeZone = convertDateToAnotherTimeZone(now, 'America/Vancouver');
            const diff = mentorTimeZone.getTime() - ttoTimeZone.getTime();
            const diffHours = diff / (1000 * 60 * 60);
            if (diffHours === 0) return '+0 hours'
            return diffHours > 0 ? `+${diffHours} hours` : `${diffHours} hours`;
        },
        getEmbedUrl(url) {
            if (url.includes('youtu.be') || url.includes('youtube.com')) {                
                const videoId = extractYouTubeId(url);
                return 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&muted=1';
            }            
            else if (url.includes('vimeo.')) {                
                const videoId = url.split('/').pop();                
                return 'https://player.vimeo.com/video/' + videoId + '?portrait=0&autoplay=1&autopause=0&byline=0&title=0&muted=1';
            }
        },
        getPathName(pathId) {
            const path = this.paths.find(p => p.id == pathId);
            if (path) {
                return path.name;
            } else {
                return null;
            }
        },
        closeLightbox() {
            this.lightbox = {
                imageSet: null,
                image: null,
                index: null,
                video: null
            }
        },        
        updateMentor() {
            const update = {
                public: this.mentor.public,
                id: this.mentor.id
            }
            mentors.togglePublic(update).then((response)=>{
                response.data.success === true ? toastr.success('Updated') : toastr.error('Error updating');
            });            
        },
        getPaths() {
            paths.getPaths(true).then((p) => {                
                this.paths = p;
            });        
        },
        getRequests() {            
            const now = new Date();

            mentors.getRequests(this).then((response) => {
                let requests = uniqBy(response.data.requests, (r) => r.id);
                const availability = this.mentor.availabilities.find(a => new Date(a.term.startDate) > now);
                const termId = availability.term.id;

                const alreadySubmitted = requests.find(r => {                    
                    return r.term === termId && r.mentorId === this.mentor.user.id;
                });

                if (alreadySubmitted) {
                    this.alreadySubmitted = true;
                }


                const alreadyApproved = requests.find((r)=>{
                    return r.term === termId && r.approvedByMentor && r.approvedByStudent;                
                });

                if (alreadyApproved) {
                    this.alreadyApproved = true;
                } else {

                    requests = requests.filter((r)=>{
                        return r.term === termId
                    }).filter((r)=>{
                        let isOpen = false;
                        if (r.approvedByMentor === null) {
                            isOpen = true;
                        }
                        if (r.approvedByMentor === true && r.approvedByStudent === null) {
                            isOpen = true;
                        }
                        return isOpen;
                    });

                    if (requests.length >= 3) {
                        this.connectionLimitReached = true;
                    }
                }

                
            });
        },
        getMentor() {
            return mentors.getProfile(this, this.mentorId).then(async (response) => {
                const mentor = response.data.profile;
                mentor.mentor_software_proficiencies = mentor.mentor_software_proficiencies.sort((a, b) => {
                    if (a.proficiencyLevel > b.proficiencyLevel) {
                        return -1;
                    }
                    if (a.proficiencyLevel < b.proficiencyLevel) {
                        return 1;
                    }
        
                    return a.mentor_software.name.localeCompare(b.mentor_software.name);
                });
                mentor.mentor_skill_proficiencies = mentor.mentor_skill_proficiencies
                .filter(s => s.mentor_skill.name)
                .sort((a, b) => {
                    if (a.proficiencyLevel > b.proficiencyLevel) {
                        return -1;
                    }
                    if (a.proficiencyLevel < b.proficiencyLevel) {
                        return 1;
                    }            
                    return a.mentor_skill.name.localeCompare(b.mentor_skill.name);
                });
                const now = new Date();

                mentor.availabilities = mentor.mentor_availabilities.slice(0, 2)
                    .filter(a => a.status === 'available' || a.status === 'unavailable')
                    .map((a) => {
                        a.connections = mentor.user.mentor_requests.filter((r)=>{
                            return r.term === a.term.id && r.approvedByMentor && r.approvedByStudent;
                        });
                    
                        return a;
                });        
                if (!mentor.user.mentees) mentor.user.mentees = [];
                if (mentor.bio) { mentor.bio = linkifyHtml(mentor.bio); }
                if (mentor.demoReelUrl) {                    
                    if (mentor.demoReelUrl.includes('vimeo')) {
                        
                        const videoId = mentor.demoReelUrl.split('/').pop().split('?')[0];
                        try {                                  
                            await axios.head('https://vimeo.com/api/oembed.json?url=https://vimeo.com/' + videoId); 
                            
                            const thumbnailLink = await axios.get(`https://vimeo.com/api/v2/video/${videoId}.json`)                            
                            if (thumbnailLink.status.toString().startsWith('2')) {
                                let thumb = thumbnailLink.data[0].thumbnail_large || thumbnailLink.data[0].thumbnail_medium || thumbnailLink.data[0].thumbnail_small;                            
                                this.demoReelAccessible = true;
                                mentor.demoReelThumbnail = thumb;
                            }                           
                        } catch(e) {    
                            // reel was deleted or set to private                        
                        }
                        
                    } else if (mentor.demoReelUrl.includes('youtube.com') || mentor.demoReelUrl.includes('youtu.be')) {
                        try {
                            const available = await axios.head('https://www.youtube.com/oembed?url=' + mentor.demoReelUrl);
                            if (available && available.status.toString().startsWith('2')) {
                                const videoId = extractYouTubeId(mentor.demoReelUrl);
                                const thumb = `https://img.youtube.com/vi/${videoId}/0.jpg`;
                                mentor.demoReelThumbnail = thumb;
                                this.demoReelAccessible = true;
                            }                          
                            
                        } catch(e) {
                            
                            // deleted, invalid URL, or set to private
                        }                        
                        
                    }
                }
                mentor.pastMentoredStudents = mentor.pastMentoredStudents.filter((s)=>{                    
                    return s.images && s.images.length;
                });

                mentor.pastMentoredStudents = await Promise.all(mentor.pastMentoredStudents.map(async(s)=>{
                    if (s.reel) {
                        const thumb = await this.getThumbnail(s.reel);
                        s.reelThumbnail = thumb;                        
                    }
                    return s;
                }));
                
                this.mentor = mentor;
                return true;
            });
        },
        async getThumbnail(reelUrl) {            
            
            if (reelUrl.includes('vimeo.')) {
                const videoId = reelUrl.split('/').pop().split('?')[0];
                return axios.get(`https://vimeo.com/api/v2/video/${videoId}.json`).then((thumbnailLink)=>{                                                                
                    let thumb = thumbnailLink.data[0].thumbnail_large || thumbnailLink.data[0].thumbnail_medium || thumbnailLink.data[0].thumbnail_small;                                                                            
                    return thumb;
                }).catch((e)=>{
                    console.log(e)
                })
                
            } else if (reelUrl.includes('youtube.com') || reelUrl.includes('youtu.be')) {
                const videoId = extractYouTubeId(reelUrl);
                const thumb = `https://img.youtube.com/vi/${videoId}/0.jpg`;
                return thumb;
            }

        },
        connectToMentor() {
            if (!this.connectionAllowed) return;
            if (this.connectionLimitReached) return;
            if (this.alreadyApproved) return;
            if (this.alreadySubmitted) return;

            if (!this.isAvailable) {
                toastr.error('This mentor already has the maximum number of students, or is not available');
                return;
            }
            this.connect = true;
        },
        sendRequest() {
            var self = this;
            
            if (!this.requestComplete) {
                toastr.error('Please fill out all fields');
                return false;
            }

            let text = ``;

            text += `<p><b>I would like you as my mentor because:</b><br> ${this.request.reason}</p>`;
            text += `<p><b>Here is a collection of my recent work (links):</b><br> ${this.request.work}</p>`;
            text += `<p><b>What I expect to get out of this mentorship:</b><br> ${this.request.expectations}</p>`;

            try {
                const person = this.$store.state.person;
                if (person) {
                    text += `<p><b>Location: </b><br> ${person.city}, ${person.province}, ${person.country}</p>`;
                }
                
                const userTimezone = moment.tz.guess();
                if (userTimezone) {
                    text += `<p><b>Time zone:</b><br> ${userTimezone}</p>`;
                }
            } catch(e) {
                console.log(e);
            }           
            
            let data = {
                mentorId: this.mentor.userId,
                text: text
            }
            
            mentors.request(this, data).then((response) => {
                if (response.data.success === true) {
                    toastr.success('Request sent');
                    this.connect = false;
                    this.getRequests();
                    this.request = {
                        reason: null,
                        work: null,
                        expectations: null                    
                    }
                } else {
                    toastr.error(response.data.message);
                }
            });
        },
        lightboxPrev() {
            if (this.lightbox.index > 0) {
                this.lightbox.index--;
                this.lightbox.image = this.lightbox.imageSet[this.lightbox.index];
            }
        },
        lightboxNext() {
            if (this.lightbox.index < this.lightbox.imageSet.length - 1) {
                this.lightbox.index++;
                this.lightbox.image = this.lightbox.imageSet[this.lightbox.index];
            }        
        },
        openLightbox(imageSet, index, video) {            
            if (imageSet === 'menteeReel') {                
                this.lightbox.video = video;
                this.$forceUpdate();
            }
            else if (imageSet === 'demoReel') {  
                this.lightbox.video = video;
                this.$forceUpdate();
            } else {
                if (!this.sliderLocked) {
                    this.lightbox.imageSet = imageSet;            
                    this.lightbox.image = this.lightbox.imageSet[index];   
                    this.lightbox.index = index;                  
                }
            }
            
                
        }
    },
    computed: {
        requestComplete() {
            return (this.request.reason && this.request.reason.trim() !== '') && (this.request.work && this.request.work.trim() !== '') && (this.request.expectations && this.request.expectations.trim() !== '');        
        },
        isAvailable() {
            if (this.mentor) {
                const now = new Date();
                const nextTerm = this.mentor.availabilities.find((a)=>{ return new Date(a.term.startDate) > now });
                if (nextTerm.status !== 'available') {
                    return false;
                }

                if (localStorage.path && localStorage.path == '9200' && this.mentor.user.path != 9200) {
                    if (!this.mentor.allStudentPaths) {
                        return false;
                    }
                }
                const taken = nextTerm.connections.length;
                if (taken >= nextTerm.seats) {
                    return false;
                }                
                return true;
                
            }
        },
      
        isCorrectVenue() {
            const now = new Date();
            let allowed = true;
            const roles = JSON.parse(localStorage.roles);   
            
            const nextTerm = this.mentor.availabilities.find((a)=>{ return new Date(a.term.startDate) > now });
            
            if (nextTerm.venue === 'campus') {
                if (roles.includes('Student') && localStorage.transitioned != 'true') {
                    allowed = false;
                }
            }
            return allowed;
        },
        tooltipText() {
            if (!this.connectionAllowed) return 'Mentor selections will be made available to you at a later date. Check your Journey page for details.';
            if (this.connectionLimitReached) return 'Maximum 3 open connections allowed at a time.'
            if (this.alreadyApproved) return 'You already have a connection for this term.';
            if (this.alreadySubmitted) return 'You have already submitted a request to this mentor.'
            return null;
        },

        connectionAllowed() {
            const settings = this.$store.getters.settings;
            let allowed = false;
            const now = new Date();

            if (settings && settings.length > 0) {
                let overrides = settings.find((s)=>{return s.name=== 'mentorSelectorOverride'}).data;
                const overridden = overrides.includes(parseInt(localStorage.user_id));
                let setting;
                if (localStorage.roles.includes('CampusStudent') || localStorage.transitioned == 'true') {
                    setting = settings.find((s)=>{return s.name=== 'campusMentorSelectionAllowed'}).value;
                } else {
                    setting = settings.find((s)=>{return s.name=== 'onlineMentorSelectionAllowed'}).value;
                }
                let studentGroups = localStorage.group.split(',');
                let inCampusMentorshipGroup = (studentGroups.includes('21'));
                if (setting === true && (overridden === true || localStorage.terms.split(',').length === 3 || (localStorage.roles.includes('CampusStudent') && inCampusMentorshipGroup))) {
                    allowed = true;
                }
            }

            const nextTerm = this.mentor.availabilities.find((a)=>{ return new Date(a.term.startDate) > now });
            
            if (nextTerm.venue === 'campus') {
                const roles = JSON.parse(localStorage.roles);                
                if (roles.includes('Student') && localStorage.transitioned != 'true') {
                    allowed = false;
                }
            }

          
            return allowed;
        },

        availableDays() {
            if (this.mentor.availableDays === 'both') return 'weekdays and weekends';
            return this.mentor.availableDays;
        },
        availableTimes() {
            if (this.mentor.availableTimes === 'any') return 'any time';
            return 'in the ' + this.mentor.availableTimes;
        },
        venue() {
            if (this.mentor) {
                const now = new Date();
                const nextTerm = this.mentor.availabilities.find((a)=>{ return new Date(a.term.startDate) > now });
                if (nextTerm.venue === 'both') return 'on Campus and Online';
                if (nextTerm.venue === 'campus') return 'on Campus';
                if (nextTerm.venue === 'online') return 'Online';
            }           
            
            
        }
    }
}

</script>
<style lang="scss">
.mentor-profile {

    .slick-arrow {
        background:transparentize(#3cf, .5);
        border-radius:50%;
        width:40px;
        height:40px;
        border: none;
        color:#333;
        position:absolute;
        z-index:99999;
        font-size:2rem;
        line-height:28px;
        text-align:center;
        cursor:pointer;
        padding-bottom:4px;
        &:hover {
            background:transparentize(#3cf, .1);        
        }
    }
    .slick-next {
        padding-left:8px;
        right:0;
        top:calc(50% - 20px);
    }
    .slick-prev {
        padding-right:8px;
        left:0;
        top:calc(50% - 20px);
    }
    .slick-list { margin: 0 -10px; }
    .slick-slide > div { padding: 0 10px; }

}
.mentor-profile .swiper-wrapper {
    height: 100vh;

    .swiper-slide {
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

</style>
<style lang="scss" scoped>
.panel {
    background: #0f0f0f;
}

.demo-reel-thumbnail {
    position:relative;
    .play-button-wrapper {
        position:absolute;
        width:100%;
        height:100%;
        top:0;
        left:0;
        right:0;        
        display:flex;
        align-items:center;
        justify-content:center;
        img {
            width:60px;
            height:60px;
        }
    }
}

.mentor-header {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    position: relative;
    height: 200px;
    margin-bottom: 2rem;

    &>div {
        position: relative;
        z-index: 999;
        height: 200px;
    }

    .col-xs-2 {
        padding: 0;
    }

    .col-xs-10 {
        position: relative;
    }

    .current-mentees {
        position: absolute;
        bottom: 0;
        right: 0;
        max-width: 400px;
        background: rgba(0, 0, 0, .45);
        padding: .35rem 1rem;

        ul {
            display: flex;
            align-items: center;
            justify-content: space-around;
            background: transparent;
        }

        li {
            padding: 0 .5rem;
            background: transparent;
        }
        .term-availability {
            display: flex;
            align-items:center;
        }
        .checkbox {
            position: relative;
            border: 2px solid #444;
            background: transparent;
            width: 16px;
            height: 16px;
        }

        .fa-check {
            color: #444;
            font-size: 18px;
            position: absolute;
            top: -2px;
            left: -2px;

            &.green {
                color: #2DA21D;
            }
        }
        .fa-remove {
            font-size: 18px;
            position:absolute;
            top:-2px;
            left:-1px;
            &.red {
                color:red;
            }
        }
        .unconfirmed {
            font-size:12px;            
            padding-left:.5rem;
            opacity:.65;
        }
    }

    .avatar {
        max-width:100%;
        width: 200px;
         height: 200px;
        object-fit: cover;
    }
}

.mentor-header::after {
    display: block;
    position: relative;
    background-image: linear-gradient(to left, rgba(50, 50, 50, .55) 0, #222 70%);
    top: -200px;
    height: 200px;
    width: 100%;
    content: '';
    z-index: 9;
}

.name,
{
    display: inline-block;
}
.position {
    display:block;
}

.availability {
    display: block;
}

.subsection-header {
    position:relative;    
    span {
        background: #0f0f0f;    
        padding: 0 2rem;
        position:relative;
        z-index: 2;
    }
    &::after {
        content: '';
        display: block;
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        height: 2px;
        background: #444;
        z-index: 1;

    }    
}

ul.tags {
    display:flex;
    align-items:center;
    justify-content:flex-start;
    flex-wrap:wrap;
    margin-bottom:4rem;
    li {
        padding:1rem;
        margin-bottom:.5rem;
        // min-width:160px;
        div {
            padding:.5rem 1.5rem;
            font-weight:700;
            border-radius:10px;
            text-align:center;
            border:3px solid #636262;
            cursor:default;
            font-weight:normal;
            font-size:16px;
            &.level-2 {
                background:#00a652;
                color: #fafafa;                           
            }
            &.level-1 {
                background:#7d7d7d;
                color: #fafafa;                           
            }
        }
    }
}
.legend {    
    display:flex;
    align-items:center;
    justify-content:center;
    .tags {
        border:1px solid darken(#ccc,30%);
        border-radius:4px;
        padding:1rem;
        justify-content:center;
        li {
            margin:0;
        }
    }
}
.name,
.availability,
.position,
.company {

    font-size: 2rem;
    font-weight: 300;
}

.name {
    color: #fafafa;
    font-size: 18pt;
    margin-top:2rem;

}

.availability {
    color: #b0b0b0;
}

.position {
    color: #fafafa;
}

.fa-remove {
    z-index: 9999999;
}

.past-students {
    .avatar-wrapper {
        display:flex;
        justify-content:center;
        img {
            max-height:200px;
            object-fit:cover;
        }
    }
    .header {
        padding:1rem;
        display:flex;
        & > div {
            width:50%;
            

        }
        .meta {
            display:flex;
            align-items:center;
            justify-content:center;
            flex-direction:column;
            padding:2rem;
        }
    }
    .links {
        text-align:center;
    }
    .images {
        display: flex;
        justify-content:center;
        li {
            width:25%;
            padding:1rem;
            img {
                height:320px;
                width:100%;
                object-fit:cover;
                cursor:pointer;
            }
        }
    }
    
}

h3 {
    font-size: 18pt;
    color: #fafafa;
    font-weight: 300;
    margin: 1rem 0 2rem 0;
}

a {
    text-decoration: underline;
}

.connect {
    background: #33ccff;
    position: absolute;
    top: 0;
    right: 0;
    color: #000;
    padding: .8rem 1.5rem;
    border: none;
    &.disabled {
          background: #666;
          opacity: .5;
          cursor:default;
          cursor: default;
    }
}
.mentor-data-section {
    margin-bottom:4rem;
}
.email {
    text-align:center;
    margin-top:2rem;
    a {
        padding-left:3rem;
        padding-right:3rem;
    }
}

.specialties {
    display: flex;
    flex-wrap: wrap;
    max-width: 80%;

    //max-height: 40px;
    //justify-content:center;
    a {
        color: inherit;
    }
    li {
        margin: .5rem 1rem .5rem 0;
        padding: .25rem 1rem;
        border: 1px solid #777;
        &:hover {
            background: #333;

        }
    }
}

.bio-wrapper {
    h3 {
        margin-top:0;
        span {
            padding-left:0;
        }
    }
}
.bio {
    margin-bottom: 1rem;
}

.links {
    margin-top: 1rem;
    display: flex;
    align-items: center;
    justify-content: space-around;
    li {
        margin-top: 1rem;
    }
}

.gallery {
    display: flex;
    flex-wrap: wrap;

    li {
        width: 33.3333%;
        padding: 1rem;
        cursor: pointer;
    }

    &.credits li {
        width: 20%;
        padding: 0;
        margin-right: 1rem;
    }
}

.work-samples {
    img {
        width:100%;
        height:240px;
        object-fit:cover;
    }
}

.mentor-info {
    border: 2px solid rgba(255,255,255,0.2);
    color:#f0f0f0;
    padding:1rem 2rem;
    margin-left:-1.6rem;
}

.modal-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999999;
    background: rgba(0, 0, 0, .75);
    display: flex;
    align-items: center;
    justify-content: center;
    textarea::-webkit-scrollbar {
        width: 6px;        
    }

    textarea::-webkit-scrollbar-track {
        // -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    }

    textarea::-webkit-scrollbar-thumb {
      background-color: #b0b0b0;
      cursor:pointer;
      outline: 1px solid slategrey;
    }


    .modal-box {
        width: 510px;
        height: 610px;
        border: 1px solid #fff;
        text-align: center;
        border: 3px solid #111;
        background: #555;
        position: relative;
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;
        padding: 0 3rem;
        &::after {
            display: block;
            content: '';
            background: rgba(50, 50, 50, .75);
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 1;
        }
        label {
            width:100%;
            text-align:left;
            color:#fff;
            
        }

        textarea {
            // height: 350px;
            border: 2px solid black;
            box-shadow: inset 0px 0px 190px rgba(0, 0, 0, .5);
        }

        textarea,
        img,
        button,
        label,
        .required-message,
        h3 {
            z-index: 999;
            position: relative;
        }
    }

    h3 {
        margin-top: -60px;
    }

    .avatar {
        width: 150px;
        height: 150px;
        object-fit: cover;
        position: relative;
        top: -75px;
        border: 3px solid #111;
    }

    textarea {
        width:100%;
        background: #333;
        color: #fafafa;
        padding: 10px;
        resize:none;
    }

    // textarea {
    //     resize: none;
    //     width: 400px;
    //     height: 350px;
    
    // }

    button {
        margin-top: 1rem;
        padding: 5px 20px;
        border: 1px solid #3cf;

    }

}
iframe.demo-reel {
    width:100vw;
    height:100vh;
}
.gallery-slider {    
    margin-bottom:4rem;
    img {
        height:220px;
        width:100%;
        object-fit:cover;
        cursor:pointer;
    }


}

.credits-slider {    
    img {
        height:300px;
        object-fit:cover;
    }
}

ul.mentees {
    display:flex;
    flex-wrap:wrap;
    margin: 0 -1rem;
    margin-bottom:4rem;
    li {
        width:25%;
        padding:1rem;
        .mentee {
            border: 1px solid #3cf;
            padding:.5rem;
            height:360px;
            display:flex;
            flex-direction:column;
            justify-content:space-between;
            overflow:hidden;
        }

        img {
            height:240px;
            width:100%;
            object-fit:cover;
            // object-position:center;
        }        
    }
    .venue {
        text-align:right;
        padding-right:.5rem;
        height:2rem;
    }
}
.swiper-button-white {
    &.disabled {
        opacity:.5;
    }
}
.overlay {
    position:fixed;
    top:0;
    left:0;
    width:100%;
    height:100%;
    background:rgba(0,0,0,.75);
    z-index:9999999;
    display:flex;
    align-items:center;
    justify-content:center;
    .fa-remove {
        font-size:3rem;
        cursor: pointer;
        position: absolute;
        top: 1rem;
        right: 1rem;
    }   
}
.lightbox {
    .fa-remove {
        font-size:3rem;
    }
}
.selected-mentee {
    width:900px;
    min-height:400px;
    max-width:100%;
    max-height:100%;
    border:1px solid #3cf;
    background:#000;
    padding: 1rem 2rem;
    position:relative;
    iframe {
        width:100%;
        height:100%;
    }
    h3 {
        font-size:20px;
        color:#3cf;
        margin:.5rem 0;
    }
    .mentee-reel {        
        width:100%;
        height:100%;
    }
    .images {
        display:flex;
        flex-wrap:wrap;
        margin: 0 -1rem;
        li {
            width:20%;
            padding:1rem;
            img {
                width:100%;
                height:180px;
                object-fit:cover;
                cursor:pointer;
            }
        }
    }
    .mentee-reel-thumbnail {
        cursor: pointer;
        position:relative;
        img.thumbnail {
            height:200px;
            width:100%;
            object-fit:cover;        
        }
        .play-button {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
        }

    }
    .reel {
        margin: 2rem 0;
    }
    p {
        white-space: pre-line
    }
    .mentee-info {
        display: flex;
        align-items: center;
        justify-content:flex-start;
        a {
            margin-left:2rem;
            padding-top:4px;
        }

        h4 {
            font-size:20px;
            // border:1px solid #3cf;
            // padding:.5rem;
        }
        .email-button {
            background:#444;
            border:1px solid #777;
            color:#fafafa;
            text-decoration:none;
            padding:.5rem 2rem;
            margin:0;
            cursor:pointer;
            &:hover {
                background: darken(#444,10%);
            }

        }

    }
}
.red { color: red; }
</style>



// WEBPACK FOOTER //
// MentorProfile.vue?52d85c90